import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UploaderComponent } from '../../../shared/uploader/uploader.component';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {combineLatest, Subject} from 'rxjs';
import { BusinessCodeService } from 'src/app/services/business/business-code/business-code.service';
import { RootService } from 'src/app/services/root.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { DocumentsService } from 'src/app/services/business/documents/documents.service';
import {
  capitalizeFirstLetter,
  removeAllSpacingBetweenWords,
} from '../../../helpers';

@Component({
  selector: 'app-business-code-update',
  templateUrl: './business-code-update.component.html',
  styleUrls: ['./business-code-update.component.scss'],
})
export class BusinessCodeUpdateComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private codeService: BusinessCodeService,
    private rootService: RootService,
    private notification: NzNotificationService,
    private docService: DocumentsService
  ) {}
  countries = [];
  cities = [];
  districts = [];
  // tslint:disable-next-line:variable-name
  form_update = this.fb.group({
    name: ['', Validators.required],
    enterpriseCode: [
      '',
      [Validators.required, Validators.pattern('[a-zA-Z0-9]*')],
    ],
    glnCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
    taxCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
    countryId: ['', Validators.required],
    address: ['', Validators.required],
    city: ['', Validators.required],
    district: ['', Validators.required],
    phone: ['', Validators.pattern('[0-9]*')],
    email: [
      '',
      Validators.pattern(
        '[a-z0-9_\\.]{1,32}@[a-z0-9]{2,}(\\.[a-z0-9]{2,4}){1,2}$'
      ),
    ],
    website: [''],
    avatar: [''],
    cover: [''],
    documents: [this.fb.control([]), [Validators.required]],
    addressNewName: [null, [Validators.maxLength(255)]],
    provinceNewId: [null, [Validators.required]],
    wardNewId: [null, [Validators.required]],
    addressNew: [true],
  });
  // id business update
  id;
  // tslint:disable-next-line:variable-name
  show_update = false;
  documents: any[] = [];
  files: any[] = [];
  avatar: any[] = [];
  // tslint:disable-next-line:variable-name
  avatar_id;
  cover: any[] = [];
  // tslint:disable-next-line:variable-name
  cover_id;
  unsubscribe$ = new Subject<void>();
  notDocuments = false;
  isDisableAddressNew = false;
  validName = false;
  validenterpriseCode = false;
  validGlnCode = false;
  validTaxCode = false;
  validAddress = false;
  messGLN = '';
  status: number;
  valueForm: any;
  cityNew: any = [];
  listWard: any = [];
  @Output() emitData = new EventEmitter();
  // @ts-ignore
  @ViewChild('selectDocument') selectDocument;
  // @ts-ignore
  @ViewChild('createDocument') createDocument;
  loading = false;
  // tslint:disable-next-line:variable-name
  country_id;
  // tslint:disable-next-line:variable-name
  country_code;
  addressDisplay;

  protected readonly JSON = JSON;

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight',
    });
    // console.log("oniti");
    this.form_update.get('addressNew').valueChanges
      .subscribe(addressNew => {
        console.log('addressNew hẹ hẹ', addressNew);
        if (this.country_code === 'VN') {
          this.updateAddressValidation(this.form_update.get('addressNew').value);
        }
        // this.isDisableAddressNew = false;
      });

    // Chỉ log khi cả 3 giá trị province_id, district_id, address đều có
    combineLatest([
      this.form_update.get('city').valueChanges,
      this.form_update.get('district').valueChanges,
      this.form_update.get('address').valueChanges,
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([provinceId, districtId, address]) => {
        if (provinceId && districtId && address) {
          const query = {
            type: 1,
            parentId: 0,
            cityOldId: provinceId,
            // wardOldId: districtId
          };
          this.rootService.getLocationOld(query).subscribe(res => {
            // console.log("res", res)
            if (res.code === 1 && res.data && res.data.cityNew && res.data.cityNew.name) {
              this.addressDisplay = [address, res.data.cityNew.name].join(', ');
            }
          });
        } else {
          this.addressDisplay = '';
        }
      });


    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      // console.log("res", res)
      this.cityNew = res.data.data;
      // console.log("this.city2", this.cityNew)
    });

    this.form_update.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      console.log('val_kkk', val);
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });
  }

  updateAddressValidation(addressNew: boolean) {
    if (addressNew) {
      // Khi addressNew = true: bỏ required cho province_id, district_id, streetId, address
      this.form_update.get('city').clearValidators();
      this.form_update.get('district').clearValidators();
      this.form_update.get('address').clearValidators();

      // Thêm required cho addressNewName, provinceNewId, wardNewId
      this.form_update.get('addressNewName').setValidators([Validators.required, Validators.maxLength(255)]);
      this.form_update.get('provinceNewId').setValidators([Validators.required]);
      this.form_update.get('wardNewId').setValidators([Validators.required]);
    } else {
      // Khi addressNew = false: thêm required cho province_id, district_id, streetId, address
      this.form_update.get('city').setValidators([Validators.required]);
      this.form_update.get('district').setValidators([Validators.required]);
      this.form_update.get('address').setValidators([Validators.required, Validators.maxLength(255)]);

      // Bỏ required cho addressNewName, provinceNewId, wardNewId
      this.form_update.get('addressNewName').clearValidators();
      this.form_update.get('provinceNewId').clearValidators();
      this.form_update.get('wardNewId').clearValidators();
    }

    // Cập nhật validation cho tất cả các field
    this.form_update.get('city').updateValueAndValidity();
    this.form_update.get('district').updateValueAndValidity();
    this.form_update.get('address').updateValueAndValidity();
    this.form_update.get('addressNewName').updateValueAndValidity();
    this.form_update.get('provinceNewId').updateValueAndValidity();
    this.form_update.get('wardNewId').updateValueAndValidity();
  }

  buildForm() {
    this.form_update = this.fb.group({
      name: ['', Validators.required],
      enterpriseCode: [
        '',
        [Validators.required, Validators.pattern('[a-zA-Z0-9]*')],
      ],
      glnCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
      taxCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
      countryId: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      district: ['', Validators.required],
      phone: ['', Validators.pattern('[0-9]*')],
      email: [
        '',
        Validators.pattern(
          '[a-z0-9_\\.]{1,32}@[a-z0-9]{2,}(\\.[a-z0-9]{2,4}){1,2}$'
        ),
      ],
      website: [''],
      avatar: [''],
      cover: [''],
      documents: [this.fb.control([]), [Validators.required]],
      addressNewName: [null, [Validators.maxLength(255)]],
      provinceNewId: [null, [Validators.required]],
      wardNewId: [null, [Validators.required]],
      addressNew: [true],
    });
  }
  getData() {
    this.notDocuments = false;
    this.avatar = [];
    this.cover = [];
    this.documents = [];
    this.codeService.one(this.id).subscribe(
      (res) => {
        if (res.code === 1) {
          const data = res.data;
          this.show_update = true;
          this.form_update.controls.name.setValue(data.name);
          this.form_update.controls.enterpriseCode.setValue(
            data.enterpriseCode
          );
          this.form_update.controls.glnCode.setValue(data.glnCode);
          this.form_update.controls.taxCode.setValue(data.taxCode);
          let code = '';
          this.countries.map((c) => {
            if (c.id === data.countryId) {
              code = c.code;
              this.form_update.controls.countryId.setValue(c.id + '-' + c.code);
            }
          });
          // if (code !== 'VN') {
          //   this.form_update.controls.city.clearValidators();
          //   this.form_update.controls.city.disable();
          //   this.form_update.controls.district.clearValidators();
          //   this.form_update.controls.district.disable();
          // }
          console.log('code', code);
          if (code === 'VN') {
            this.getDistricts(data.provinceId);
            this.form_update.controls.city.setValue(data.provinceId || undefined);
            this.form_update.controls.district.setValue(data.districtId || undefined);
          }
          this.form_update.controls.address.setValue(data.address);
          this.form_update.controls.phone.setValue(data.phone);
          this.form_update.controls.email.setValue(data.email);
          this.form_update.controls.website.setValue(data.website);
          this.form_update.controls.addressNew.setValue(data.addressNew);
          this.form_update.controls.addressNewName.setValue(data.addressNewName);
          this.form_update.controls.provinceNewId.setValue(data.provinceNewId || undefined);
          this.form_update.controls.wardNewId.setValue(data.wardNewId || undefined);
          // if (this.form_update.get('countryId').value === 241) {
          //   this.country_code = code;
          // }
          this.country_code = code;
          console.log("xxxxxxxxxx", code)
          setTimeout(() => {
            // this.country_code = code;
            if (code === 'VN') {
              // this.form_update.controls.city.setValidators(Validators.required);
              // this.form_update.controls.city.enable();
              // this.form_update.controls.district.setValidators(Validators.required);
              // this.form_update.controls.district.enable();
              // this.form_update.controls.provinceNewId.setValidators(Validators.required);
              // this.form_update.controls.provinceNewId.enable();
              // this.form_update.controls.wardNewId.setValidators(Validators.required);
              // this.form_update.controls.wardNewId.enable();
            } else {
              this.citiChange(null);
              // this.form_update.controls.city.clearValidators();
              // this.form_update.controls.city.disable();
              // this.form_update.controls.district.clearValidators();
              // this.form_update.controls.district.disable();

              // this.form_update.controls.provinceNewId.clearValidators();
              // this.form_update.controls.provinceNewId.disable();
              // this.form_update.controls.wardNewId.clearValidators();
              // this.form_update.controls.wardNewId.disable();
            }
          }, 500);

          // if (data.addressNew) {
          //   this.form_update.controls.city.setValue( null);
          //   this.form_update.controls.district.setValue(null);
          //   this.form_update.controls.address.setValue(null);
          // } else {
          //   this.form_update.controls.addressNewName.setValue(null);
          //   this.form_update.controls.provinceNewId.setValue(null);
          //   this.form_update.controls.wardNewId.setValue(null);
          // }
          // console.log("xxxx", this.form_update.value)
          data.documents.map((item) => {
            const doc = {
              documentId: item.id,
              url: item.url,
              title:
                item.title !== null && item.title.length > 100
                  ? item.title.slice(0, 100) + '...'
                  : item.title,
              value: item.value,
            };
            this.documents.push(doc);
          });
          // tslint:disable-next-line:no-shadowed-variable
          this.documents.map((res) => {
            this.selectDocument.setId(res.id, true);
          });
          if (data.avatar) {
            const avatar = {
              type: 'jpeg',
              name: 'demo',
              url: data.avatar_org,
            };
            this.avatar_id = data.avatar;
            this.avatar.push(avatar);
          }
          if (data.cover) {
            const cover = {
              type: 'jpeg',
              name: 'demo',
              url: data.cover_org,
            };
            this.cover.push(cover);
            this.cover_id = data.cover;
          }
          this.form_update.controls.documents.setValue(data.documents);
          // tslint:disable-next-line:radix
          this.status = parseInt(data.status);
          // console.log(data.status, this.status, this.form_update);
          // tslint:disable-next-line:radix
          if (parseInt(data.status) === 1) {
            this.valueForm = data;
            // console.log(data);
            const keys = [
              'name',
              'enterpriseCode',
              'glnCode',
              'countryId',
              'address',
              'city',
              'district',
              'taxCode',
            ];
            keys.map((key) => {
              this.form_update.controls[key].disable({ onlySelf: true });
            });
          } else {
            this.valueForm = data;
            // console.log(data);
            const keys = [
              'name',
              'enterpriseCode',
              'glnCode',
              'countryId',
              'address',
              'city',
              'district',
              'taxCode',
            ];
            keys.map((key) => {
              this.form_update.controls[key].enable();
            });
          }
          console.log("code", code)
          if (data.status == 1) {
            this.isDisableAddressNew = true;
          } else {
            this.isDisableAddressNew = false;
          }
          // if (data.status == 1 && data.addressNew) {
          //   this.form_update.controls.addressNew.disable({ onlySelf: true });
          //   this.form_update.controls.addressNewName.disable({ onlySelf: true });
          //   this.form_update.controls.provinceNewId.disable({ onlySelf: true });
          //   this.form_update.controls.wardNewId.disable({ onlySelf: true });
          // } else {
          //   this.form_update.controls.addressNew.enable();
          //   this.form_update.controls.addressNewName.enable();
          //   this.form_update.controls.provinceNewId.enable();
          //   this.form_update.controls.wardNewId.enable();
          // }
        } else {
          this.notification.create(
            'error',
            'Lấy thông tin mã doanh nghiệp thất bại',
            res.message
          );
        }
      },
      (error) => {
        this.notification.create(
          'error',
          'Lấy thông tin mã doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  modalDocument() {
    this.selectDocument.setCheckboxAll();
    this.documents.map((res) => {
      this.selectDocument.setId(res.documentId, true);
    });
    this.selectDocument.showModal();
  }

  newDocument(event) {
    event.title = capitalizeFirstLetter(
      removeAllSpacingBetweenWords(event.title)
    );
    this.docService.create(event).subscribe(
      (res) => {
        if (res.code === 1) {
          this.createDocument.hide();
          const data = {
            documentId: res.data.documentId,
            title:
              res.data.title !== null && res.data.title.length > 100
                ? res.data.title.slice(0, 100) + '...'
                : res.data.title,
          };
          this.documents.push(data);
          this.notDocuments = false;
          this.documents.map((item) => {
            this.selectDocument.setId(item.documentId, true);
          });
          return;
        }
        this.notification.create('error', 'Thêm giấy tờ thất bại', res.message);
      },
      (error) => {
        this.notification.create(
          'error',
          'Thêm giấy tờ thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  selectDocuments(event) {
    const newList = [];
    event.ids.map((item, key) => {
      const data = {
        documentId: item,
        title:
          event.titles[key] && event.titles[key] !== null && event.titles[key].length > 100
            ? event.titles[key].slice(0, 100) + '...'
            : event.titles[key],
      };
      newList.push(data);
    });
    this.documents = newList;
    this.notDocuments = this.documents.length <= 0;
    this.selectDocument.handleCancel();
  }

  inputChange(event) {
    this[event] = false;
  }
  citiChange(event) {
    if (event === null) {
      this.form_update.controls.city.clearValidators();
      this.form_update.controls.city.disable();
      this.form_update.controls.district.clearValidators();
      this.form_update.controls.district.disable();
      this.form_update.controls.provinceNewId.clearValidators();
      this.form_update.controls.provinceNewId.disable();
      this.form_update.controls.wardNewId.clearValidators();
      this.form_update.controls.wardNewId.disable();
      this.form_update.controls.city.setValue(null);
      this.form_update.controls.district.setValue(null);
      this.form_update.controls.provinceNewId.setValue(null);
      this.form_update.controls.wardNewId.setValue(null);
      return;
    }
    console.log('xxx', event);
    this.country_code = event.split('-')[1];
    if (this.country_code !== 'VN') {
      this.form_update.controls.city.clearValidators();
      this.form_update.controls.city.disable();
      this.form_update.controls.district.clearValidators();
      this.form_update.controls.district.disable();
      this.form_update.controls.provinceNewId.clearValidators();
      this.form_update.controls.provinceNewId.disable();
      this.form_update.controls.wardNewId.clearValidators();
      this.form_update.controls.wardNewId.disable();

      this.form_update.controls.city.setValue(null);
      this.form_update.controls.district.setValue(null);
      this.form_update.controls.provinceNewId.setValue(null);
      this.form_update.controls.wardNewId.setValue(null);
      return;
    }
    this.form_update.controls.city.setValidators(Validators.required);
    this.form_update.controls.city.enable();
    this.form_update.controls.district.setValidators(Validators.required);
    this.form_update.controls.district.enable();
    this.form_update.controls.provinceNewId.setValidators(Validators.required);
    this.form_update.controls.provinceNewId.enable();
    this.form_update.controls.wardNewId.setValidators(Validators.required);
    this.form_update.controls.wardNewId.enable();
  }
  update() {

    this.messGLN = '';
    // this.form_update.get('documents').setValue(this.documents);
    if (this.documents.length) {
      const docs = [];
      this.documents.map((item) => {
        // tslint:disable-next-line:triple-equals
        if (item.id != undefined) {
          docs.push(item.id);
        }
        // tslint:disable-next-line:triple-equals
        if (item.documentId != undefined) {
          docs.push(item.documentId);
        }
      });
      this.form_update.get('documents').setValue(docs);
    } else {
      this.notDocuments = true;
      return;
    }
    // tslint:disable-next-line:forin
    for (const i in this.form_update.controls) {
      this.form_update.controls[i].markAsDirty();
      this.form_update.controls[i].updateValueAndValidity();
    }
    if (this.form_update.invalid) {
      return;
    }
    const name$ =
      this.status !== 1 ? this.form_update.value.name : this.valueForm.name;
    const enterpriseCode$ =
      this.status !== 1
        ? this.form_update.value.enterpriseCode
        : this.valueForm.enterpriseCode;
    const glnCode$ =
      this.status !== 1
        ? this.form_update.value.glnCode
        : this.valueForm.glnCode;
    const taxCode$ =
      this.status !== 1
        ? this.form_update.value.taxCode
        : this.valueForm.taxCode;
    const countryId$ =
      this.status !== 1
        ? this.form_update.value.countryId.split('-')[1]
        : this.valueForm.countryId;
    // console.log(countryId$);
    const address$ =
      this.status !== 1
        ? this.form_update.value.address
        : this.valueForm.address;
    if (name$.trim().length === 0) {
      this.validName = true;
    } else {
      this.validName = false;
    }
    if (enterpriseCode$.trim().length === 0) {
      this.validenterpriseCode = true;
    } else {
      this.validenterpriseCode = false;
    }
    if (glnCode$.trim().length === 0) {
      this.messGLN = 'Mã GLN không hợp lệ';
      this.validGlnCode = true;
    } else {
      this.messGLN = '';
      this.validGlnCode = true;
    }
    const gln = glnCode$.substr(0, enterpriseCode$.length);
    // tslint:disable-next-line:triple-equals
    if (gln != enterpriseCode$ && glnCode$.trim()) {
      this.messGLN = 'GLN phải có prefix trùng với mã doanh nghiệp';
      this.validGlnCode = true;
    } else {
      this.messGLN = '';
      this.validGlnCode = false;
    }
    if (taxCode$ && taxCode$.trim().length === 0) {
      this.validTaxCode = true;
    } else {
      this.validTaxCode = false;
    }
    if (address$ && address$.trim().length === 0) {
      this.validAddress = true;
    } else {
      this.validAddress = false;
    }
    if (
      this.validName ||
      this.validenterpriseCode ||
      this.validGlnCode ||
      this.validTaxCode ||
      this.validAddress ||
      this.notDocuments
    ) {
      return;
    }
    this.loading = true;
    const city$ = countryId$ === 'VN' ? this.form_update.value.city : 0;
    const district$ = countryId$ === 'VN' ? this.form_update.value.district : 0;
    const phone$ = this.form_update.value.phone;
    const email$ = this.form_update.value.email;
    const website$ = this.form_update.value.website;
    const avatar$ = this.avatar_id;
    const cover$ = this.cover_id;
    const documents$ = this.form_update.value.documents;
    const addressNew = this.form_update.value.addressNew;
    const provinceNewId = this.form_update.value.provinceNewId;
    const addressNewName = this.form_update.value.addressNewName;
    const wardNewId = this.form_update.value.wardNewId;
    const body = {
      enterpriseCode: enterpriseCode$,
      glnCode: glnCode$,
      name: capitalizeFirstLetter(removeAllSpacingBetweenWords(name$)),
      address: address$,
      provinceId: this.status !== 1 ? city$ : this.valueForm.provinceId,
      districtId: this.status !== 1 ? district$ : this.valueForm.districtId,
      documents: documents$,
      taxCode: taxCode$,
      // tslint:disable-next-line:radix
      countryId:
        this.status !== 1
          ? parseInt(this.form_update.value.countryId.split('-')[0])
          : this.valueForm.countryId,
      email: email$,
      website: website$,
      phone: phone$,
      avatar: avatar$,
      cover: cover$,
      addressNew,
      provinceNewId,
      wardNewId,
      addressNewName
    };
    if (addressNew) {
      body.provinceId = null;
      body.districtId = null;
      body.address = null;
    } else {
      body.provinceNewId = null;
      body.wardNewId = null;
      body.addressNewName = null;
    }

    this.codeService.update(this.id, body).subscribe(
      (res) => {
        this.loading = false;
        // @ts-ignore
        const code = res.code;
        // @ts-ignore
        const message = res.message;
        if (code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Cập nhật mã doanh nghiệp thành công'
          );
          this.show_update = false;
          setTimeout(() => {
            this.emitData.emit(res);
          }, 1000);
          return;
        }

        this.notification.create(
          'error',
          'Cập nhật mã doanh nghiệp thất bại',
          message
        );
      },
      (error) => {

        this.loading = false;
        this.notification.create(
          'error',
          'Cập nhật mã doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  // upload file
  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          const data = {
            name: changeParam.file.name,
            type: changeParam.file.type,
            url: changeParam.file.response.url,
          };
          this[field] = [];
          this[field].push(data);
          if (field === 'avatar') {
            this.avatar_id = changeParam.file.response.url;
          }
          if (field === 'cover') {
            this.cover_id = changeParam.file.response.url;
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe((changeParam) => {
          modal.close();
        });
    });
  }

  onRemoveFile(field: string, index: number) {
    this[field] = [];
    if (field === 'avatar') {
      this.avatar_id = '';
    } else {
      this.cover_id = '';
    }
  }

  delete_up(file, index) {
    if (this.documents[index].documentId !== undefined) {
      this.selectDocument.setId(this.documents[index].documentId, false);
    }
    if (this.documents[index].id !== undefined) {
      this.selectDocument.setId(this.documents[index].id, false);
    }
    this.documents.splice(index, 1);
    if (!this.documents.length) {
      this.notDocuments = true;
    }
  }

  getCountries() {
    this.rootService.listCountries().subscribe(
      (res) => {
        this.countries = res.data.items;
      },
      (error) => {
        this.countries = [];
      }
    );
  }

  getCities() {
    const response = this.rootService.listCities();
    response.subscribe(
      (res) => {
        this.cities = res.data.items;
      },
      (error) => {
        this.cities = [];
      }
    );
  }

  getDistrictsNew($event: any) {
    this.form_update.get('wardNewId').setValue(null);
  }

  getDistricts(event) {
    this.form_update.get('district').setValue('');
    // tslint:disable-next-line:variable-name
    const province_id = event;
    if (province_id) {
      const response = this.rootService.listDistricts(province_id);
      response.subscribe(
        (res) => {
          this.districts = res.data.items;
        },
        (error) => {
          this.districts = [];
        }
      );
    }
  }

  showUpdate(id, data?) {
    this.show_update = false;
    this.show_update = true;

    this.getCountries();
    this.id = id;
    this.files = [];
    this.form_update.reset();
    // this.buildForm();
    this.getData();
    this.getCities();
    this.validName = false;
    this.validenterpriseCode = false;
    this.validGlnCode = false;
    this.validTaxCode = false;
    this.validAddress = false;
  }

  hideUpdate() {
    this.files = [];
    this.loading = false;
    this.show_update = false;

    this.form_update.reset();
  }
}
